import config from '@/config/prod.env';
import { header } from '@/helper/header';
import { common } from '@/helper/common';
import store from '@/store';
import { menuService } from '@/services/authentication/menu.service.js';
export const authenticationService = {
    login,
    logout,
    //refreshToken,
    register,
    changePassword,
    resetPassword,
    getLoginInfoFromSSO,
    updateAccountInfo,
    getPersonalDetail,
};

async function login(userName, password, appId) {
    const deviceInfo = await common.getDevideInfo();
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderNoToken(),
        body: JSON.stringify({ userName, password, appId })
    };
    return await fetch(`${config.LOGIN_URL}/Auth/Login`, requestOptions)
        .then(response => common.handleResponse(response))
        .then(res => {
            if (!res.data) {
                return { code: false, data: res };
            }
            else {
                // Lưu dữ liệu user và token vào local storage
                //res.data['savePassword'] = savePassword;
                res.data['deviceInfo'] = deviceInfo;
                delete res.data.roleInfo

                localStorage.setItem('user', JSON.stringify(res.data));
                return { code: true, data: res.data };
            }
        });
}

async function logout() {
    // Xoá user từ local storage
    localStorage.removeItem('user');
    localStorage.removeItem('menu');
}

// async function refreshToken(accessToken, refreshToken, savePassword) {
//     const deviceInfo = await common.getDevideInfo();
//     const requestOptions = {
//         method: 'POST',
//         headers: await header.authHeaderNoToken(),
//         body: JSON.stringify({ accessToken, refreshToken })
//     };
//     return await fetch(`${config.LOGIN_URL}/NguoiDung/RefreshToken`, requestOptions)
//         .then(response => common.handleResponse(response))
//         .then(res => {
//             if (!res.data) {
//                 return { code: false, data: res.message };
//             }
//             else {
//                 // Xóa dữ liệu cũ
//                 localStorage.removeItem('user');
//                 // Lưu dữ liệu user và token vào local storage
//                 res.data['savePassword'] = savePassword;
//                 res.data['deviceInfo'] = deviceInfo;
//                 localStorage.setItem('user', JSON.stringify(res.data));
//                 return { code: true, data: res.data };
//             }
//         });
// }

async function register(user) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(user)
    };
    return await fetch(`${config.LOGIN_URL}/NguoiDung/Register`, requestOptions).then(response => common.handleResponse(response));
}

async function changePassword(password, passwordNew, passwordNewConfirmed) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify({ password, passwordNew, passwordNewConfirmed })
    };
    return await fetch(`${config.LOGIN_URL}/NguoiDung/ChangePassword`, requestOptions).then(response => common.handleResponse(response));
}

async function resetPassword(userName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify({ userName })
    };
    return await fetch(`${config.LOGIN_URL}/NguoiDung/ResetPassword`, requestOptions).then(response => common.handleResponse(response));
}

async function getLoginInfoFromSSO(loginInfoId, appId) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderNoToken(),
        body: JSON.stringify({ loginInfoId, appId })
    };
    let res = await fetch(`${config.LOGIN_URL}/Auth/GetLoginInfo`, requestOptions)
        .then(response => common.handleResponse(response))

    if (!res.data) {
        return { code: false, data: res };
    }
    else {
        //Thành công
        //Lưu lại data user
        localStorage.setItem('user', JSON.stringify(res.data));
        //Lấy thông tin menu
        let menuRes = await menuService.getMenuData()

        return { code: true, data: res.data };
    }
}


async function updateAccountInfo(model) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify( model )
    };
    return await fetch(`${config.LOGIN_URL}/NguoiDung/UpdatePersonalAccount`, requestOptions).then(response => common.handleResponse(response));
}

async function getPersonalDetail(params){
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };
    return await fetch(`${config.LOGIN_URL}/NguoiDung/GetPersonalInfo`, requestOptions).then(response => common.handleResponse(response));
}